import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ElementoBusqueda } from 'src/app/models/help';
import { helpService } from 'src/app/services/help.service';
import { TokenAdmService } from 'src/app/services/token-adm.service';
import { clean } from "diacritic";

@Component({
  selector: 'app-resultados-busqueda',
  templateUrl: './resultados-busqueda.component.html',
  styleUrls: ['./resultados-busqueda.component.css']
})
export class ResultadosBusquedaComponent implements OnInit {

  terminoBusqueda:string;
  loading:boolean=false;
  resultado:ElementoBusqueda[] =[];
  errorBusqueda:boolean=false;
  ruta:string;
  noBUsco:boolean=false;

  isAdmin:boolean;
  isContribuidor:boolean;

  cantidadRegistros:number;
  cantidadPaginas:number;
  pagina:number=1;
  pageSize:number=10;

  src: string;
  data:ElementoBusqueda[] =[];
  focusElement: number = -1;
  itemlen: number = 0;
  show = true;
  loadingIncremental:boolean=false;
  noBusco:boolean=false;

  public strBusqueda: string[];

  pgrCantRegistros = [
    { valor: 3, texto: '3' },
    { valor: 5, texto: '5' },
    { valor: 10, texto: '10' },
    { valor: 20, texto: '20' },
  ];
  pgrSelectedValue: number = 10;



  constructor(private activatedRoute:ActivatedRoute, private busquedaService:helpService, private tokenService:TokenAdmService,
    private _router: Router, private location:Location) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params =>{
      this.terminoBusqueda = params['termino'];
     })
     if (sessionStorage.getItem('pageSize')){
      this.pgrSelectedValue = Number(sessionStorage.getItem('pageSize'));
      this.pageSize = Number(sessionStorage.getItem('pageSize'));

     }
     if (sessionStorage.getItem('pagina')){
      this.pagina = Number(sessionStorage.getItem('pagina'));
     }

     this.buscar( this.terminoBusqueda);
     this.isAdmin = this.tokenService.hasRole('Help_Admin')
     this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor')
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.show = false;
  }

  responderPregunta(id:number) {
    sessionStorage.setItem('pageSize',this.pageSize.toString())
    sessionStorage.setItem('pagina',this.pagina.toString())
    this.ruta = 'help/respuesta/'+id;
    this._router.navigateByUrl(this.ruta);


  }

  gotoTemas(id:number, descripcion:string) {
    sessionStorage.setItem('pageSize',this.pageSize.toString())
    sessionStorage.setItem('pagina',this.pagina.toString())
    sessionStorage.setItem('burbujaDesc',descripcion)
    this.ruta = 'help/temas/'+id;
    this._router.navigateByUrl(this.ruta);
  }


  gotoPreguntas(id:number) {
    sessionStorage.setItem('pageSize',this.pageSize.toString())
    sessionStorage.setItem('pagina',this.pagina.toString())
    this.ruta = 'help/preguntas/'+id;
    this._router.navigateByUrl(this.ruta);
  }



  buscar(terminoBusqueda: string) {
    this.strBusqueda=terminoBusqueda.split(' ');
    this.loading = false;
    if (terminoBusqueda.length>1){
       this.loading = true;
       this.busquedaService.buscarPaginadoPublic(this.pagina,this.pageSize,terminoBusqueda)
      .subscribe(
        (resp) =>{
          this.resultado = resp.body.resultado;
          this.cantidadPaginas = resp.body.cantidadPaginas;
          this.cantidadRegistros = resp.body.cantidadRegistros;
          this.errorBusqueda = false;
          this.src = terminoBusqueda;
          this.show = false;
          this.loading = false;
          this.noBusco = false;
        },
        error => {
          this.resultado =null;
          this.loading = false;
          this.show = false;
          this.src = terminoBusqueda;
          this.errorBusqueda=true;
          this.noBusco = false;
      })
    }
    else {
      this.resultado =null;
      this.loading = false;
      this.show = false;
      this.src = terminoBusqueda;
      this.errorBusqueda=false;
      this.noBusco = true;
    }
  }

  cambiarPagina(valor:number){
    this.pagina += valor;
    if (this.pagina <= 0) {
      this.pagina = 1;
    } else if (this.pagina > this.cantidadPaginas) {
      this.pagina -= valor;
    }
    this.buscar(this.terminoBusqueda);
  }

  cambiarPager() {
    this.pagina = 1;
    this.pageSize = this.pgrSelectedValue
    sessionStorage.setItem('pageSize',this.pageSize.toString())
    sessionStorage.setItem('pagina',this.pagina.toString())
    this.buscar(this.src)
  }



  searchIncremental(value: string) {
    this.loadingIncremental = true;
    this.strBusqueda=value.split(' ');
    if (value.length>1){
      this.loadingIncremental = true;
      this.show = true;
      this.busquedaService.BuscadorPublic(value)
      .subscribe(
        (resp: ElementoBusqueda[]) => {
          this.data = resp;
          this.loadingIncremental = false;
          this.errorBusqueda = false;
        },
        error => {
          this.data =[];
          this.loadingIncremental = false;
          this.errorBusqueda=true;
      })
    }
  }

  onLocationFocus() {
    this.focusElement = 0;
  }
  onLocationBlur() {
    this.focusElement = -1;

  }

  onArrowUp() {
    if (this.focusElement > 0) {
      this.focusElement--;
    }
    return false;
  }

  onEnter(value: number) {
    event.preventDefault();
    this.show = false;
    if (value==0){
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation="reload"
      this._router.navigate(['help/buscar',this.src]);
    }else{
      this._router.navigate(['help/respuesta',value]);
    }
  }


  onEsc() {
    this.show = false;
  }

  onArrowDown() {
    if (this.focusElement <= this.data.length-2) {
      this.focusElement++;
    }
  }


  gotoInicio() {
    this._router.navigateByUrl('/help');
  }

  volver() {
    this.location.back();
  }

  removeDiacritics(text: string): string {
    return clean(text);
  }

}



